import {
	Alert,
	AlertDescription,
	AlertIcon,
	Box,
	Text,
} from '@chakra-ui/react';
import { useExitComponent } from 'components/dataTables/agGridTable/PlanningTable/hooks/useExitComponentWithConfirmation';
import GenericTabs from 'components/genericTabs/GenericTabs';

import { useContextPrevision } from '../../context/ContextPrevision';
import { useTabs } from '../../hooks';
import { detailedPlanningMessages } from './detailedPlanning/variables/detailedPlanningMessages';
import PlanningTabsData from './variables/tabsConfig';

export default function MainTabs() {
	const { canView, cycle, getEditBlockReason, planningType } =
		useContextPrevision();
	const editBlockReason = getEditBlockReason(cycle);
	const { activeTab, changeTab } = useTabs(0);
	const changeActiveTab = (nextIndex: number) => {
		requestExit(() => changeTab(nextIndex));
	};
	const { requestExit } = useExitComponent();
	if (!canView)
		return (
			<Text
				textAlign={'center'}
				fontSize={'lg'}
				fontWeight={'bold'}
				color={'gray.800'}
			>
				{detailedPlanningMessages.MSG_NO_PERMISSION}
			</Text>
		);
	return (
		<Box
			px='0.75rem'
			paddingTop='6.25rem'
			display={'flex'}
			flexGrow={1}
			flexDirection='column'
		>
			{(planningType === 'collaboration' ||
				planningType === 'consensus') &&
				editBlockReason && (
				<Alert
					status='warning'
					variant='left-accent'
					mb={4}
					borderRadius='md'
				>
					<AlertIcon />
					<AlertDescription fontSize='sm'>
						{editBlockReason === 'deprecated_cycle'
							? detailedPlanningMessages.MSG_READ_ONLY_DEPRECATED_CYCLE
							: detailedPlanningMessages.MSG_READ_ONLY_NO_EDIT_PERMISSION}
					</AlertDescription>
				</Alert>
			)}
			<GenericTabs
				tabs={PlanningTabsData}
				indexTab={activeTab}
				onChange={changeActiveTab}
			/>
		</Box>
	);
}
